/* unplugin-vue-components disabled */import { render } from "./member_preferential.vue?vue&type=template&id=3099f319&scoped=true"
import script from "./member_preferential.vue?vue&type=script&lang=js"
export * from "./member_preferential.vue?vue&type=script&lang=js"

import "./member_preferential.vue?vue&type=style&index=0&id=3099f319&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3099f319"]])

export default __exports__